import { render, staticRenderFns } from "./PatientPhotoUpload.vue?vue&type=template&id=78cc5b92&"
import script from "./PatientPhotoUpload.vue?vue&type=script&lang=ts&"
export * from "./PatientPhotoUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports